import { useEffect } from 'react';
import { Easing, type SharedValue, useSharedValue, withTiming } from 'react-native-reanimated';

type UseEnterAnimationProgressOptions = {
  duration?: number;
  enabled?: boolean;
  initialValue?: number;
};

export function useEnterAnimationProgress(
  shouldAnimate: boolean,
  deps: readonly unknown[],
  {
    duration = 700,
    enabled = true,
    initialValue = 0,
  }: UseEnterAnimationProgressOptions = {}
) {
  const progress = useSharedValue(shouldAnimate ? 1 : initialValue);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!shouldAnimate) {
      progress.value = initialValue;
      return;
    }

    progress.value = initialValue;
    progress.value = withTiming(1, {
      duration,
      easing: Easing.out(Easing.cubic),
    });
  }, [duration, enabled, initialValue, progress, shouldAnimate, ...deps]);

  return progress;
}

export type { SharedValue };
